import { merge } from 'lodash'
import ReactApexChart from 'react-apexcharts'
import { alpha, useTheme } from '@mui/material/styles'
import { Box, Card, CardHeader } from '@mui/material'
import { fNumber } from 'src/utils/formatNumber'
import { BaseOptionChart } from './BaseOptionChart'

const CHART_DATA = [{ data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380] }]

export default function AppConversionRates() {
	const theme = useTheme()
	const bgPlain = { backgroundColor: theme.palette.grey[500_16] }

	const chartOptions = merge(BaseOptionChart(), {
		tooltip: {
			marker: { show: false },
			y: {
				formatter: (seriesName) => fNumber(seriesName),
				title: {
					formatter: (seriesName) => `#${seriesName}`,
				},
			},
		},
		plotOptions: {
			bar: { horizontal: true, barHeight: '28%', borderRadius: 2 },
		},
		xaxis: {
			categories: [
				'Italy',
				'Japan',
				'China',
				'Canada',
				'France',
				'Germany',
				'South Korea',
				'Netherlands',
				'United States',
				'United Kingdom',
			],
		},
	})

	return (
		<Card sx={{ ...bgPlain, minHeight: '80px', height: '100%' }}>
			<CardHeader title="Top Performing DAOs" subheader="(+43%) than last year" />
			<Box sx={{ mx: 3 }} dir="ltr">
				<ReactApexChart
					type="bar"
					series={CHART_DATA}
					options={chartOptions}
					height={364}
				/>
			</Box>
		</Card>
	)
}
